import { createRouter as _createRouter, createWebHistory } from 'vue-router';
import type { Router, RouteLocation } from 'vue-router';
import { routes } from './routes';
declare module 'vue-router' {
  interface RouteMeta {
    title?:
      | ((route: RouteLocation) => string | null)
      | ((route: RouteLocation) => Promise<string | null>)
      | string
      | null;
    layoutFeatures?: {
      sidebar?: boolean;
      actionPanel?: boolean;
      actionPanelVariant?: 'default' | 'module-header';
      pageControlsTarget?: 'start' | 'end';
      pageControlsShowQuickFilters?: boolean;
      pageControlsQuickFiltersLayout?: 'inline' | 'stacked';
      pageControlsVisibilityPlacement?: 'auto' | 'floating' | 'action-panel';
    };
  }
}
export function createRouter(): Router {
  const router = _createRouter({
    routes,
    history: createWebHistory('/'),
    linkActiveClass: '',
    linkExactActiveClass: '',
    async scrollBehavior(to, from, savedScrollPosition) {
      if (savedScrollPosition) {
        return savedScrollPosition;
      }
      if (from.path === to.path) {
        return undefined;
      }
      if (to.hash) {
        return { el: to.hash };
      }
      return { left: 0, top: 0 };
    },
  });
  router.onError((error, to) => {
    if (!__DEV__ && error.message.includes('Failed to fetch dynamically imported module')) {
      window.location.href = to.fullPath;
    }
  });
  return router;
}
